import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CameraShutterSVG = function CameraShutterSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    d: "M16.41,11,11.77,2.65A14,14,0,0,0,2.94,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.58,19H29.67A14.14,14.14,0,0,0,30,16a13.92,13.92,0,0,0-3.15-8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.34,13.94l5.08-8.28A14,14,0,0,0,16,2a14.51,14.51,0,0,0-2.2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.12,21l4.72,8.45A14,14,0,0,0,29.06,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,17.68,6,25.74A13.91,13.91,0,0,0,16,30a13,13,0,0,0,1.78-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.54,13H2.33A14.14,14.14,0,0,0,2,16a13.89,13.89,0,0,0,2.61,8.12Z"
  }));
};
CameraShutterSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CameraShutterSVG);